var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuiSuiLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3033_13944)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z",
    fill: "#6FBCF0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.20508 15.2012C6.20508 16.9355 8.00195 17.9746 10.002 17.9746C12.002 17.9746 13.7988 16.9355 14.7988 15.2012C15.7988 13.4668 15.7988 11.3965 14.7988 9.66211L10.5801 2.34961C10.3223 1.9043 9.68164 1.9043 9.42383 2.34961L5.20508 9.66211C4.19727 11.3965 4.19727 13.4668 5.20508 15.2012ZM8.81445 5.82617L9.71289 4.26367C9.83789 4.04492 10.166 4.04492 10.291 4.26367L13.752 10.2637C14.3848 11.3652 14.5098 12.6387 14.1113 13.8105C14.0723 13.623 14.0098 13.4277 13.9316 13.2324C13.4551 12.0215 12.3691 11.0918 10.7129 10.4668C9.57227 10.0371 8.8457 9.39648 8.55664 8.57617C8.18164 7.51367 8.58008 6.35742 8.81445 5.82617ZM7.27539 8.48242L6.25195 10.2637C5.4707 11.623 5.4707 13.2402 6.25195 14.5996C7.0332 15.959 8.43945 16.7637 10.002 16.7637C11.041 16.7637 12.0098 16.4043 12.7754 15.7715C12.877 15.5215 13.1816 14.6074 12.7988 13.6621C12.4473 12.7871 11.6035 12.0918 10.2832 11.5918C8.79883 11.0293 7.83008 10.1465 7.4082 8.97461C7.35352 8.81055 7.31445 8.64648 7.27539 8.48242Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3033_13944"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuiSuiLogo);
export default __webpack_public_path__ + "static/media/sui-sui-logo.c0fbedf5516bdc8a85673cb704d0fb9e.svg";
export { ForwardRef as ReactComponent };